<template>
  <div>
    <CCard>
      <CCardBody class="customContainerFluid">
        <div class="customRow" v-for="(label, i) in labels" :key="i">
          <div
            class="column-5 layoutSection"
          >
            <b class="labels">{{ label }}</b>
          </div>
          <div
            class="column-7 layoutSection"
          >
            <DxSelectBox
              :data-source="SelectBox_DS"
              :accept-custom-value="false"
              :searchEnabled="true"
              :openOnFieldClick="true"
              :placeholder="
                label == labels[0]
                  ? `[Required]`
                  : `[Not Provided]`
              "
              :minSearchLength="0"
              :showClearButton="true"
              display-expr="value"
              value-expr="key"
              :value="defaultSelectedValue(label, i)"
              :onSelectionChanged="(value) => mapIndexValues(value, i)"
            >
              <!--  For Product Instance ID  -->
              <DxValidator v-if="label == labels[0]">
                <DxRequiredRule :message="`${label}` + ' is required'" />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <div class="buttons">
      <DxButton
        text="Submit"
        @click="handleSubmit('')"
        style="background-color: #006ca5"
        type="default"
        width="120"
      />
    </div>
  </div>
</template>
<script>
import notify from "devextreme/ui/notify";
import { DxSelectBox } from "devextreme-vue";
import { DxButton } from "devextreme-vue";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import { confirm } from "devextreme/ui/dialog";

export default {
  name: "ExcelColumnMapper",
  components: { DxButton, DxSelectBox, DxValidator, DxRequiredRule },
  props: {
    CustomExcelColumn: Array,
  },
  data() {
    return {
      val: -1,
      labels: [
        "ProductInstanceID",
        "DecommissionDate",
      ],
      ExcelIndex: {
        ProductInstanceID: undefined,
        DecommissionDate: undefined,
      },
      SelectBox_DS: [],
    };
  },
  mounted: function () {
    this.generateSelectBox_DS();
  },
  methods: {
    handleSubmit() {
      let instanceID = this.ExcelIndex.ProductInstanceID;
      if (instanceID == undefined) {
        notify(
          {
            message: "Missing  required Field(s)!",
            position: {
              my: "center top",
              at: "center top",
            },
            width: "300px",
          },
          "error",
          5000
        );
      } else {
        this.mapSubmit();
      }
    },
    defaultSelectedValue(label, i) {
      let indexOfValue = this.SelectBox_DS.find((x) =>
        x.value
          .toLowerCase()
          .match(
            new RegExp("^.*" + label.toLowerCase() + ".*$", "ig")
          )
      )
        ? this.SelectBox_DS.find((x) =>
            x.value
              .toLowerCase()
              .match(
                new RegExp(
                  "^.*" + label.toLowerCase() + ".*$",
                  "ig"
                )
              )
          ).key
        : undefined;
      return indexOfValue;
    },
    generateSelectBox_DS() {
      //array to array of objects
      this.CustomExcelColumn.map((k, i) => {
        this.SelectBox_DS.push({
          key: i,
          value: k,
        });
      });

      //sort alpha by column headers
      this.SelectBox_DS = this.SelectBox_DS.sort((k, i) =>
        k.value > i.value ? 1 : -1
      );
    },
    mapSubmit() {
      let tempArray = [];
      Object.entries(this.ExcelIndex).forEach(([key, value]) => {
        tempArray.push(value);
      });
      let hasDuplicate = tempArray.some((val, i) => {
        if (val != undefined) {
          return tempArray.indexOf(val) !== i;
        }
      });

      if (hasDuplicate) {
        let result = confirm(
          "<i>Same column selected more than once, Do you want to proceed?</i>",
          "Confirm column mapping"
        );
        result.then((dialogResult) => {
          if (dialogResult) {
            this.$emit("set-excel-columns", this.ExcelIndex);
            this.$emit("hide-modal");
          }
        });
      } else {
        this.$emit("set-excel-columns", this.ExcelIndex);
        this.$emit("hide-modal");
      }
    },
    mapIndexValues(e, i) {
      if (e) {
        let indexOfSelectedColumn =
          e.selectedItem == null ? undefined : e.selectedItem.key;
        this.ExcelIndex.ProductInstanceID =
          i == 0 ? indexOfSelectedColumn : this.ExcelIndex.ProductInstanceID;
        this.ExcelIndex.DecommissionDate =
          i == 1 ? indexOfSelectedColumn : this.ExcelIndex.DecommissionDate;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.buttons {
  grid-column: 1 / 4;
  grid-row: 5 / 6;

  .dx-button {
    float: right;
    margin: 5px;
    font-size: 12px;
    padding: 4px 10px;
  }
}
.labels {
  float: left;
}
.customContainerFluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.customRow {
  display: flex;
  width: 100%;
  padding-top: 2.5px;
  padding-bottom: 2.5px;
}
.column-5 {
  width: 41.67%;
}
.column-7 {
  width: 58.33%;
}
.layoutSection {
  padding-left: 0.8em;
  padding-right: 0.8em;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
}
</style>